<script>
import PresentationEditor from './PresentationEditor.vue'

export default {
  extends: PresentationEditor,
  created() {
    document.body.classList.add('body-presentation-detail-ppt')
  },
  destroyed() {
    document.body.classList.remove('body-presentation-detail-ppt')
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";

.editor__background {
  @apply flex flex-1 min-h-0;
  background-color: #f0f2f5;
}
.middle-side-right__wrapper {
  @apply relative flex min-h-0 ml-auto;
  flex: 0 1 calc(100% - $left-nav-width);
  max-width: calc(100% - $left-nav-width);
}

.aha-presentation-editor-wrapper {
  @apply flex flex-col h-full absolute w-full;

  &.show-grid-slide {
    .aha-left-column {
      width: calc(100% - $right-nav-width);
    }
  }
  &.show-grid-slide.right-nav--opening {
    .aha-left-column {
      width: calc(100% - $opened-right-nav-width);
    }
  }
  &.right-nav--opening .middle-side-right__wrapper {
    padding-right: 98px;
  }
  min-width: 840px;

  &.powerpoint-addin {
    min-width: 960px;

    &::v-deep .aha-presentation-editor-header {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
    }

    &::v-deep .editor__background {
      padding-top: 60px;
    }
    .aha-right-nav {
      display: none;
    }
    &.enable-editor-mode {
      .aha-right-nav {
        display: block;
      }
    }
    &.disable-select-slide {
      .aha-left-column {
        cursor: not-allowed;
        pointer-events: none;
        opacity: 0.5;
      }
    }

    .aha-right-nav {
      position: fixed;
      right: 0;
      top: 60px;
    }
  }
}

.aha-presentation-editor-header.in-demo-mode {
  @apply mt-10;
}
.aha-presentation-editor-header {
  &.ppt-header {
    z-index: 11;
  }
}

.aha-left-column {
  @apply absolute left-0 z-5;
  height: calc(100% - $grid-view-button-height);
  transition: all .3s ease;
}
.take-over--side-right {
  display: none;
  @media (max-width: 768px) {
    display: none;
  }
}
.ai-panel-tooltip::v-deep {
  .close-button {
    width: 16px;
    height: 16px;
  }
}

</style>
